import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withCargoDetailsEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
